// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"fb51c11d","787":"35dd0f9c"}[chunkId] + ".chunk.js";
};